import styled from 'styled-components';

export const AppRoot = styled.div<{
  unsetAll: boolean;
}>`
  ${({ unsetAll }) =>
    !unsetAll &&
    `
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
    `}
  font-family: 'Open Sans', 'Nunito Sans', 'Roboto', 'Arial' !important;
  a {
    font-family: 'Open Sans', 'Nunito Sans', 'Roboto', 'Arial';
  }
  input {
    font-family: 'Open Sans', 'Nunito Sans', 'Roboto', 'Arial';
  }

  .MuiMenuItem-root {
    min-height: 64px !important;
  }
  .Mui-selected,
  .Mui-selected:hover {
    background-color: #eaf0f6 !important;
  }
`;
